import { Nillable } from './nillable';
import { isNil } from './is-nil';

export function executeOrNull<Type, Created>(
  value: Nillable<Type>,
  factory: (value: Type) => Created,
): Created | null {
  if (isNil(value)) {
    return null;
  }

  return factory(value);
}
